import Dexie from 'dexie';

export const db = new Dexie('RiderForHealth_DB');
db.version(2).stores({
    Roles: 'id',
    Riders: 'id',
    Province: "id",
    District: 'id',
    Tehsil: 'id',
    XpertSite: 'id',
    HCF: 'id',
    Settings: 'id',
    Patients: 'id',
    PatientSamples: 'id',
    Banks: 'id',
    ListSearchHistory: 'pageName,id',

    LoggedInUser: "id",
    ActivityLog: '++LocalId ,UserId',
});

// '[userId+pageName],id'

export const Admintables = ["Roles", "Riders", "Province", "District", "Tehsil", "XpertSite", "HCF", "Settings", "Banks", "ListSearchHistory"]
export const BHUtables = ["Riders", "XpertSite", "Settings", "Patients", "PatientSamples", "Banks", "ListSearchHistory"]
export const RHCtables = ["Riders", "XpertSite", "HCF", "Settings", "Patients", "PatientSamples", "Banks", "ListSearchHistory"]
export const XpertSitetables = ["Riders", "HCF", "Settings", "Patients", "PatientSamples", "Banks", "ListSearchHistory"]
export const Ridertables = []
export const DistrictFieldSupervisortables = []
